module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2022_fr-c3c083f4706f902cc200a8893f6d5709.jpg";